import React, { FC } from 'react';
import { IEventDetail } from '../eventInterface';
import { Typography } from '@getgo/chameleon-web/react';
import RichTextContent from '../../utils/richTextContent/richTextContent';

export interface IEventOverview {
  eventDetail: IEventDetail;
}

const EventOverview: FC<IEventOverview> = ({ eventDetail }) => (
  <Typography className="preserve-line-breaks" variant="body-small" color="neutral">
    <RichTextContent>{eventDetail.description}</RichTextContent>
  </Typography>
);

export default EventOverview;
